import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/images/oilservice.png'


const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "layout hero" }
const _hoisted_3 = { class: "overlay" }
const _hoisted_4 = { class: "hero-content" }
const _hoisted_5 = { class: "hero-buttons" }
const _hoisted_6 = {
  href: "tel:+491234567890",
  class: "call-button"
}
const _hoisted_7 = {
  href: "https://wa.me/491234567890?text=Hallo%20ich%20möchte%20einen%20Termin%20vereinbaren",
  target: "_blank",
  rel: "noopener",
  class: "whatsapp-btn"
}
const _hoisted_8 = { class: "layout features" }
const _hoisted_9 = { class: "card feature-box animate-on-scroll" }
const _hoisted_10 = { class: "card feature-box animate-on-scroll" }
const _hoisted_11 = { class: "card feature-box animate-on-scroll" }
const _hoisted_12 = { class: "services-grid" }
const _hoisted_13 = { class: "full-width-card animate-on-scroll" }
const _hoisted_14 = { class: "about-contact" }
const _hoisted_15 = { class: "contact-left animate-on-scroll" }
const _hoisted_16 = { class: "ueberuns" }
const _hoisted_17 = { class: "header" }
const _hoisted_18 = { class: "contact" }
const _hoisted_19 = { class: "header" }

import {onBeforeUnmount, onMounted} from "vue";
import {Calendar, CarFront, Check, Hammer, NotebookText, Phone, Smartphone} from "lucide-vue-next";
import '@/assets/styles/home.css';


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

/**
 * Logo, Slogan, Pictures and first Impressions
 * Short overview about services
 * Call-to-action button: Book your appointment
 *
 * TODO: View should start at the Beginning when switching pages
 *
 * --add Logo
 */

let observer: IntersectionObserver | null = null;

onMounted(() => {
  const elements = document.querySelectorAll(".animate-on-scroll");

  observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer?.unobserve(entry.target);
          }
        });
      },
      {threshold: 0.18}
  );

  elements.forEach((element) => observer?.observe(element));
});

onBeforeUnmount(() => {
  observer?.disconnect();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("span", { class: "hero-kicker" }, "Demo-Website · KFZ Musterwerkstatt", -1)),
          _cache[4] || (_cache[4] = _createElementVNode("h1", null, "Ihre KFZ-Werkstatt für Qualität, Sicherheit und Vertrauen", -1)),
          _cache[5] || (_cache[5] = _createElementVNode("p", null, "Ob Inspektion, Reparatur oder spezialisierte Serviceleistungen – bei uns ist Ihr Fahrzeug in besten Händen. Wir stehen für zuverlässige Arbeit, transparente Preise und moderne Technik. Unser Ziel: Sie schnell, sicher und sorgenfrei wieder auf die Straße zu bringen. ", -1)),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: "/contact",
              class: "appointment-button"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Calendar)),
                _cache[0] || (_cache[0] = _createElementVNode("span", null, "Buchen Sie Ihren Termin", -1))
              ]),
              _: 1
            }),
            _createElementVNode("a", _hoisted_6, [
              _createVNode(_unref(Phone)),
              _cache[1] || (_cache[1] = _createTextVNode(" Anrufen ", -1))
            ]),
            _createElementVNode("a", _hoisted_7, [
              _createVNode(_unref(Smartphone)),
              _cache[2] || (_cache[2] = _createTextVNode(" Termin über WhatsApp vereinbaren ", -1))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_unref(NotebookText)),
        _createVNode(_component_router_link, {
          to: "/services",
          class: "sides-link"
        }, {
          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
            _createElementVNode("h2", null, "Inspektion und Wartung", -1)
          ]))]),
          _: 1
        }),
        _cache[7] || (_cache[7] = _createElementVNode("p", null, " Regelmäßige Wartung ist entscheidend für die Lebensdauer Ihres Fahrzeugs. Wir führen Inspektionen nach Herstellervorgaben durch, wechseln Öl und Flüssigkeiten und prüfen alle sicherheitsrelevanten Komponenten. So vermeiden Sie teure Folgeschäden und bleiben jederzeit mobil. ", -1))
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_unref(Hammer)),
        _createVNode(_component_router_link, {
          to: "/services",
          class: "sides-link"
        }, {
          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
            _createElementVNode("h2", null, "Reparaturen und Fahrzeugdiagnose", -1)
          ]))]),
          _: 1
        }),
        _cache[9] || (_cache[9] = _createElementVNode("p", null, " Ob Motor, Getriebe oder Elektronik – wir finden die Ursache und kümmern uns darum, dass Ihr Fahrzeug wieder zuverlässig läuft. Mithilfe moderner Diagnosetechnik lassen sich Fehler gezielt eingrenzen, sodass unnötige Arbeiten vermieden werden. Von kleineren Reparaturen bis hin zu umfangreicheren Instandsetzungen arbeiten wir sorgfältig, transparent und mit Blick auf das Wesentliche. Sie erhalten eine ehrliche Einschätzung, was sinnvoll ist – damit Ihr Fahrzeug schnell und ohne unnötige Kosten wieder einsatzbereit ist. ", -1))
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_unref(CarFront)),
        _createVNode(_component_router_link, {
          to: "/services",
          class: "sides-link"
        }, {
          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
            _createElementVNode("h2", null, "Spezialservices & Werterhalt", -1)
          ]))]),
          _: 1
        }),
        _cache[11] || (_cache[11] = _createElementVNode("p", null, " Von Getriebeölspülungen über Klimaservice bis hin zum Austausch von Windschutzscheiben: Unsere Zusatzleistungen sorgen für mehr Komfort, Sicherheit und den langfristigen Werterhalt Ihres Fahrzeugs. ", -1))
      ])
    ]),
    _createElementVNode("section", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _cache[16] || (_cache[16] = _createElementVNode("h3", null, "Ihre Vorteile auf einen Blick", -1)),
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createVNode(_unref(Check), { class: "icon" }),
            _cache[12] || (_cache[12] = _createTextVNode(" Fachgerechte Arbeit nach aktuellen Standards ", -1))
          ]),
          _createElementVNode("li", null, [
            _createVNode(_unref(Check), { class: "icon" }),
            _cache[13] || (_cache[13] = _createTextVNode(" Moderne Diagnose- und Werkstatttechnik ", -1))
          ]),
          _createElementVNode("li", null, [
            _createVNode(_unref(Check), { class: "icon" }),
            _cache[14] || (_cache[14] = _createTextVNode(" Transparente Beratung und faire Preise ", -1))
          ]),
          _createElementVNode("li", null, [
            _createVNode(_unref(Check), { class: "icon" }),
            _cache[15] || (_cache[15] = _createTextVNode(" Schnelle Terminvergabe und zuverlässiger Service ", -1))
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_router_link, {
              to: "/about#about-view",
              class: "sides-link"
            }, {
              default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                _createElementVNode("h2", null, "Über uns", -1)
              ]))]),
              _: 1
            })
          ]),
          _cache[18] || (_cache[18] = _createElementVNode("div", { class: "about-info" }, [
            _createElementVNode("p", null, " KFZ Musterwerkstatt steht für zuverlässige Kfz-Reparaturen, kompetente Beratung und ehrlichen Service. Mit moderner Technik und langjähriger Erfahrung sorgen wir dafür, dass Ihr Fahrzeug sicher, zuverlässig und schnell wieder auf die Straße kommt. ")
          ], -1))
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_router_link, {
              to: "/contact",
              class: "sides-link"
            }, {
              default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                _createElementVNode("h2", null, "Kontakt", -1)
              ]))]),
              _: 1
            })
          ]),
          _cache[20] || (_cache[20] = _createElementVNode("div", { class: "contact-info" }, [
            _createElementVNode("p", null, "KFZ Musterwerkstatt"),
            _createElementVNode("p", null, "Musterstraße 12"),
            _createElementVNode("p", null, "12345 Musterstadt"),
            _createElementVNode("p", null, "Telefon: +49 (0)1234 567890"),
            _createElementVNode("p", null, "E-Mail: info@musterwerkstatt.example")
          ], -1)),
          _cache[21] || (_cache[21] = _createElementVNode("div", { class: "header" }, [
            _createElementVNode("h3", null, "Öffnungszeiten")
          ], -1)),
          _cache[22] || (_cache[22] = _createElementVNode("div", { class: "contact-info" }, [
            _createElementVNode("p", null, "Mo. - Fr. 08:00-17:00")
          ], -1))
        ])
      ]),
      _cache[23] || (_cache[23] = _createElementVNode("div", { class: "contact-right animate-on-scroll" }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "Oil-service"
        })
      ], -1))
    ])
  ]))
}
}

})